import CryptoJS from 'crypto-js'

const configCms = {
    '589': {
        secret: 'a81eb3df418d83d6a1a4b7c572156d2f',
        key: 'a81eb3df418d83d6',
    },
    '5873': {
        secret: '41c479790a76f86326f89e8048964739',
        key: '41c479790a76f863'
    },
    '4123': {
        secret: 'df2c88338b85f830cebce2a9eab56628',
        key: 'df2c88338b85f830',
    }
}

// ASE解密
export function Decrypt(word, platformID) {
    let key = configCms[platformID].key
    let iv = configCms[platformID].key

    key = CryptoJS.enc.Utf8.parse(key)
    iv = CryptoJS.enc.Utf8.parse(iv)

    let base64 = CryptoJS.enc.Base64.parse(word)
    let src = CryptoJS.enc.Base64.stringify(base64)
    // 解密模式为CBC，补码方式为PKCS5Padding（也就是PKCS7）
    let decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    })

    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
}

// ASE加密
export function Encrypt(word, platformID) {
    let key = configCms[platformID].key
    let iv = configCms[platformID].key

    key = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);

    let srcs = CryptoJS.enc.Utf8.parse(word);
    // 加密模式为CBC，补码方式为PKCS5Padding（也就是PKCS7）
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/*************************************************
 * @desc 处理时间 M-D h-m
 * @param {time}-需要处理的时间
 * @return {time} - -MM-DD h-m
 */
export function timeFormatDHM (time) {
    let timer = time ? new Date(time) : new Date()
    return `${(timer.getMonth() + 1) < 10 ? '0' + (timer.getMonth() + 1) : (timer.getMonth() + 1)}-${timer.getDate() < 10 ? '0' + timer.getDate() : timer.getDate()} ${timer.getHours() < 10 ? '0' + timer.getHours() : timer.getHours()}:${timer.getMinutes() < 10 ? '0' + timer.getMinutes() : timer.getMinutes()}`
  }



// WEBPACK FOOTER //
// ./src/tools/ase.js